import React, { Component } from 'react';
import { Route, Switch, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Layout, Menu, Spin, Avatar, Popover, Badge } from 'antd';
import {
    HomeOutlined, IdcardOutlined, TableOutlined, LikeOutlined, StarOutlined,
    TagsOutlined, DashboardOutlined, FundOutlined, AuditOutlined,
    UsergroupAddOutlined, MenuUnfoldOutlined, MenuFoldOutlined
} from '@ant-design/icons';
import { find, isEmpty } from 'lodash';

import MainContent from './MainContent';
import StartScreen from './components/StartScreen';
import Db365Logo from './components/Db365Logo';
import common from './common';
import currentuser from './modules/currentuser';
import uistate from './modules/uistate';
import management from './modules/management';
import globalappstate from './modules/globalappstate';
import releasenotes from './modules/releasenotes';
import reports from './modules/reports';
import incidents from './modules/incidents';
import processingactivities from './modules/processingactivities';
import reporting from './modules/reporting';

import Todo from './components/Todo';
import WaitingForApprovalScreen from './components/WaitingForApprovalScreen';
import DelegatedWaitingForApprovalScreen from './components/DelegatedWaitingForApprovalScreen';


const { Settings } = uistate;
const { ReleaseNotesGrid } = releasenotes;
const { LocalUsersTable, EditStartScreen } = management;
const { MyReportsGrid, ReportDetails, ComplianceReportsGrid, ReportsGrid } = reports;
const { IncidentsGrid, IncidentDetails } = incidents;
const { ComplianceActivitiesGrid, ActivityDetails, MyActivitiesGrid } = processingactivities;

const { currentUserHasRights } = common;
const { Header, Footer, Sider } = Layout;

class ShelRoot extends Component {
    state = {
        height: 0,
        visible: false,
        renderAdministrationMenu: false,
        openmenukeys: []
    }
    label = (key) => {
        return common.getLabel(this.props.labels, "shellroot", 'MenuItems', key);
    }

    UNSAFE_componentWillMount() {
        this.props.loadLabels();
        this.props.loadUserSettings();
        this.props.fetchStartupData();
    }

    setHeigthParam = (height) => {
        this.props.saveHeightParam(height);
    }
    setWidthParam = (width) => {
        this.props.saveWidthParam(width);
    }
    toggle = () => {
        let { shellSettings } = this.props.uistate;
        shellSettings.collapsed = !shellSettings.collapsed

        this.props.saveShellSettings(shellSettings);
    }


    showDrawer = () => {
        this.setState({
            visible: true,
        });
    };

    onClose = () => {
        this.setState({
            visible: false,
        });
    };

    onMenuOpenChange = (openkeys) => {
        if (openkeys.length > 1) {
            this.setState({
                openmenukeys: [openkeys[openkeys.length - 1]]
            });
        } else {
            this.setState({
                openmenukeys: openkeys
            });
        }
    }

    render() {
        const { collapsed } = this.props.uistate.shellSettings;
        const loading = this.props.currentuser.idUser === 0;

        const userHasAdminRights = find(this.props.currentuser.rights, ['right', common.rights.AdministerApplication]) ? true : false;
        const userHasNoAccess = find(this.props.currentuser.rights, ['right', common.rights.NoAccess]) ? true : false;
        const userIsSupervisor = find(this.props.currentuser.rights, ['right', common.rights.ManageUserReport]) ? true : false;
        const userHasViewReportingRights = find(this.props.currentuser.rights, ['right', common.rights.ViewReporting]) ? true : false;
        const userHasReadComplianceReportsRights = find(this.props.currentuser.rights, ['right', common.rights.ReadAllComplianceReports]) ? true : false;
        const userHasReadComplianceIncidentsRights = find(this.props.currentuser.rights, ['right', common.rights.ReadAllComplianceIncidents]) ? true : false;
        const userHasReadComplianceProcActivitiesRights = find(this.props.currentuser.rights, ['right', common.rights.ReadComplianceProcessingActivities]) ? true : false;

        const totalActionCount = this.props.currentuser.counters.waitingForApprovalTasks
            + this.props.currentuser.counters.delegatedTasks
            + this.props.currentuser.counters.delegatedActivityTasks
            + this.props.currentuser.counters.waitingForApprovalActivityTasks;

        const mySubItems = [
            { key: 'myreports', icon: <TableOutlined />, label: <Link to={`/app/myreports`}>{this.label("MenuItemTitleMyReports")}</Link> },
            this.props.currentuser.verwerkingsRegisterEnabled && { key: 'myactivities', icon: <TableOutlined />, label: <Link to={`/app/myactivities`}>{this.label("MenuItemTitleMyActivities")}</Link> },
            this.props.currentuser.kycRegisterUrl && { key: 'kycregister', icon: <TableOutlined />, label: <a href={this.props.currentuser.kycRegisterUrl} target="_blank">{this.label("MenuItemTitleKyc")}</a> },
        ].filter(Boolean);

        const approvalSubItems = [
            {
                key: 'approval', label:
                    <Link to={`/app/approvals`}>
                        <Badge count={this.props.currentuser.counters.waitingForApprovalTasks + this.props.currentuser.counters.waitingForApprovalActivityTasks}
                            className={collapsed ? "badgeCountCollapsed2" : "badgeCountExpanded"}>
                            <StarOutlined /><span style={{ marginLeft: 8 }}>{this.label("MenuItemTitleMyTasks")}</span>
                        </Badge>
                    </Link>
            },
            {
                key: 'delegatedapprovals', label:
                    <Link to={`/app/delegated`}>
                        <Badge count={this.props.currentuser.counters.delegatedTasks + this.props.currentuser.counters.delegatedActivityTasks}
                            className={collapsed ? "badgeCountCollapsed2" : "badgeCountExpanded"}>
                            <TagsOutlined /><span style={{ marginLeft: 8 }}>{this.label("MenuItemTitleDelegatedTasks")}</span>
                        </Badge>
                    </Link>
            },
        ];

        const reportSubItems = [
            userHasReadComplianceReportsRights && { key: 'igioreports', icon: <TableOutlined />, label: <span onClick={() => this.props.getIgIoExport()}>{this.label("ReportIgIoReports")}</span> },
            ...(this.props.picklists.reportItems || []).map(r => ({ key: r.idReportItem, icon: <TableOutlined />, label: <a href={r.url} target="_blank">{r.name}</a> })),
        ].filter(Boolean);

        const complianceSubItems = [
            userHasReadComplianceReportsRights && { key: 'compliancereports', icon: <TableOutlined />, label: <Link to={`/app/compliance/reports`}>{this.label("MenuItemTitleComplianceReports")}</Link> },
            userHasReadComplianceIncidentsRights && { key: 'complianceincidents', icon: <TableOutlined />, label: <Link to={`/app/compliance/incidents`}>{this.label("MenuItemTitleComplianceIncidents")}</Link> },
            this.props.currentuser.verwerkingsRegisterEnabled && userHasReadComplianceProcActivitiesRights && { key: 'complianceactivities', icon: <TableOutlined />, label: <Link to={`/app/compliance/processingactivities`}>{this.label("MenuItemTitleComplianceActivities")}</Link> },
        ].filter(Boolean);

        const menuItems = [
            { key: 'dashboard', icon: <HomeOutlined />, label: <Link to={'/'}>{this.label("MenuItemTitleHome")}</Link> },
            !userHasNoAccess && { key: 'subp', icon: <IdcardOutlined />, label: this.label("MenuTitleMe"), children: mySubItems },
            (!userHasNoAccess || userIsSupervisor) && {
                key: 'appr',
                label: <Badge count={totalActionCount} className={collapsed ? "badgeCountCollapsed" : "badgeCountExpanded"}>
                    <LikeOutlined /><span style={{ marginLeft: 8 }}>{this.label("MenuTitleActions")}</span>
                </Badge>,
                children: approvalSubItems,
            },
            userIsSupervisor && { key: 'manager', icon: <DashboardOutlined />, label: this.label("MenuTitleManager"), children: [{ key: 'reports', icon: <TableOutlined />, label: <Link to={`/app/reports`}>{this.label("MenuItemTitleReports")}</Link> }] },
            userHasViewReportingRights && { key: 'subreports', icon: <FundOutlined />, label: this.label("MenuTitleReports"), children: reportSubItems },
            (userHasReadComplianceReportsRights || userHasReadComplianceIncidentsRights) && { key: 'compliance', icon: <AuditOutlined />, label: this.label("MenuTitleCompliance"), children: complianceSubItems },
            userHasAdminRights && {
                key: 'submanagement', icon: <UsergroupAddOutlined />, label: this.label("MenuItemTitleManagement"), children: [
                    { key: 'management', label: <Link to={'/app/management'}>{this.label("SubMenuItemTitleRolesRights")}</Link> },
                    { key: 'editstartscreen', label: <Link to={'/app/management/startscreen'}>{this.label("SubMenuItemTitleEditStartScreen")}</Link> },
                    { key: 'releasenotes', label: <Link to={'/app/management/releasenotes'}>{this.label("SubMenuItemTitleReleaseNotes")}</Link> },
                ]
            },
        ].filter(Boolean);

        return (
            <div>
                <Layout className="ant-layout-has-sider container">
                    <Sider width={250} theme="dark" trigger={null} collapsible collapsed={collapsed} >
                        <Db365Logo large={!collapsed} menuItems={this.props.picklists.db365MenuItems} />
                        <div>
                            {!collapsed &&
                                <img alt="logo" src='/img/BN-LogoFull.png' style={{
                                    width: '153px',
                                    padding: '0px 0px 0px 18px'
                                }} />
                            }
                        </div>
                        <Menu theme="dark" mode="inline" openKeys={this.state.openmenukeys} onOpenChange={this.onMenuOpenChange} items={menuItems} />
                    </Sider>
                    <Layout style={{ padding: 0, background: 'white', height: '100vh', overflowY: 'hidden' }}>
                        <Header style={{ background: '#fff', padding: 5, paddingTop: 0 }}>
                            <div className="app-header-title-wrapper">
                                {collapsed
                                    ? <MenuUnfoldOutlined className="trigger" onClick={this.toggle} />
                                    : <MenuFoldOutlined className="trigger" onClick={this.toggle} />
                                }
                                <div className="app-header-title" style={{ display: 'flex' }}>
                                    <span>{this.label("HeaderApplicationTitle")}</span>
                                </div>
                                <div style={{ float: 'right', marginRight: 16, alignItems: 'center' }}>
                                    <Popover placement="bottomRight" content={<Settings userisadmin={userHasAdminRights} mobile={false} labels={this.props.labels} />} trigger="click">
                                        <Avatar src={`https://mdmapi.ballast-nedam.nl/api/prs/image/user?width=900&height=120&id=${this.props.currentuser.idUser}`}
                                            title={this.props.currentuser ? this.props.currentuser.displayname : ""} />
                                    </Popover>
                                </div>
                            </div>
                        </Header>
                        <MainContent onHeightRecorded={this.setHeigthParam} onWidthRecorded={this.setWidthParam} style={{ margin: '0 5px' }}>
                            {
                                loading ? (
                                    <div className="loader-content"  >
                                        <Spin size="large" />
                                    </div>
                                ) : (
                                    <div style={{ padding: 0, background: '' }}>
                                        <Switch>
                                            <Route path="/app/todo" render={(props) => (<Todo {...props} title='... todo ...' />)} />

                                            <Route path="/app/approvals" component={WaitingForApprovalScreen} />
                                            <Route path="/app/delegated" component={DelegatedWaitingForApprovalScreen} />
                                            <Route path="/app/myreports" component={MyReportsGrid} />
                                            <Route path="/app/myactivities" component={MyActivitiesGrid} />

                                            <Route path="/app/reports/:repId/" render={(props) => (<ReportDetails {...props} />)} />
                                            <Route path="/app/reports" component={ReportsGrid} />

                                            <Route path="/app/processingactivities/:repId/" render={(props) => (<ActivityDetails {...props} />)} />
                                            {/* <Route path="/app/processingactivities" component={ReportsGrid} /> */}

                                            <Route path="/app/compliance/reports" component={ComplianceReportsGrid} />
                                            <Route path="/app/compliance/incidents" component={IncidentsGrid} />
                                            <Route path="/app/compliance/processingactivities" component={ComplianceActivitiesGrid} />

                                            <Route path="/app/incidents/:repId/" render={(props) => (<IncidentDetails {...props} />)} />

                                            <Route path="/app/management/startscreen" component={EditStartScreen} />
                                            <Route path="/app/management/releasenotes" component={ReleaseNotesGrid} />

                                            <Route path="/app/management" component={LocalUsersTable} />

                                            <Route path="/app" component={StartScreen} />
                                        </Switch>
                                    </div>
                                )
                            }
                        </MainContent>
                    </Layout>
                </Layout>
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        uistate: state[uistate.constants.NAME],
        currentuser: state[currentuser.constants.NAME],
        labels: uistate.selectors.uiLabels(state),
        picklists: globalappstate.selectors.allPicklists(state),
    };
}

export default connect(mapStateToProps,
    {
        fetchStartupData: currentuser.actions.fetchStartupData,
        loadUserSettings: uistate.actions.loadUserSettings,
        saveShellSettings: uistate.actions.saveShellSettings,
        loadLabels: uistate.actions.loadLabels,
        saveHeightParam: uistate.actions.saveHeightParam,
        saveWidthParam: uistate.actions.saveWidthParam,
        getIgIoExport: reporting.actions.getIgIoExport,

    })(ShelRoot);
